module.exports = "data:image/gif;base64,R0lGODlhCQAJAMQWAERERHx8fIaGhr29vU9PT6+vr5SUlJGRkZqamkpKSmNjY5ycnHZ2doyMjKSkpHp6enFxcVRUVEZGRlZWVmpqamxsbP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAABYALAAAAAAJAAkAAAUuoCVaxmgiQ2RaaCEQozEUSwPBRqUUxzElAFFgcBAkTAGHgCFBCh6U4ChAAFhFIQA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/col-move-bottom.gif
 ** module id = 456
 ** module chunks = 0
 **/